import { FormControlLabel, Grid, Typography, createStyles, makeStyles } from '@material-ui/core';
import ErrorText from '../ErrorText';
import Form from '../AuthForm';
import Input from '../AuthInput';
import RememberCheckbox from '../../Login/RememberCheckbox';
import cn from 'classnames';
import commonStyles from '../../styles';
import loginStyles from '../../Login/styles';
import { useTranslation } from 'react-i18next';

type Props = {
  email: string;
  password: string;
  isEmailValid: boolean;
  setEmail(e: string): void;
  setPassword(e: string): void;
  error: string;
  onSubmit: () => void;
};

const LoginForm = ({ email, password, isEmailValid, setEmail, setPassword, error, onSubmit }: Props): JSX.Element => {
  const { link, rememberMe, typographySecondary, typographyForgotPassw } = makeStyles((theme) =>
    createStyles({ ...loginStyles(theme), ...commonStyles(theme) })
  )();
  const { t } = useTranslation();

  return (
    <Form>
      <ErrorText>{error}</ErrorText>
      <Input
        label={t('auth.email')}
        handleSubmit={onSubmit}
        type="email"
        value={email}
        error={!isEmailValid}
        handleChange={setEmail}
      />
      <Input
        label={t('password')}
        handleSubmit={onSubmit}
        type="password"
        value={password}
        handleChange={setPassword}
      />
      <Grid container item justifyContent="space-between">
        <FormControlLabel className={rememberMe} control={<RememberCheckbox />} label={t('auth.remember.me')} />
        <Typography className={cn(typographyForgotPassw, link)}>
          <a className={typographySecondary} href="/restore-password">
            {t('auth.forgot.password')}
          </a>
        </Typography>
      </Grid>
    </Form>
  );
};

export default LoginForm;
